const RECRUIT_SITE_URL = 'https://sp-thanks.com/recruit/';

export default function Header() {
  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-[#060148]">
      <div className="mx-auto flex h-20 w-full max-w-6xl items-center justify-between px-5 sm:px-8">
        <a
          href={RECRUIT_SITE_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Special Thanks 採用サイト"
          className="flex min-w-0 items-center"
        >
          <img
            src="https://storage.readdy-site.link/project_files/d1a56358-40cc-43d1-9b4f-cab4994326e5/6964feca-cb5c-4d96-b50f-059937fdaeee_-2.png?v=8f7a0dfffe927c74f4a6017d01de41df"
            alt="Special Thanks"
            className="h-10 w-auto object-contain sm:h-12"
          />
        </a>

        <a
          href={RECRUIT_SITE_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="font-cta inline-flex min-h-11 items-center whitespace-nowrap text-[14px] leading-none text-white transition-colors duration-200 hover:text-white/80 sm:text-[15px]"
        >
          採用サイトを見る →
        </a>
      </div>
    </header>
  );
}
